import React from "react";

const TabView = ({ children }) => {
  return <div>{children}</div>;
};

export default TabView;
